// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-text[data-v-33dcdc58]{hyphens:auto;overflow-wrap:break-word;padding:.8em;white-space:normal;width:100%;word-break:break-word}.message-text[data-v-33dcdc58] p{margin-bottom:16px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
